import { Component, OnInit } from '@angular/core';
import { BookingFinalConfirmationTemplate } from '../booking-final-confirmation-template';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';

import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-booking-final-confirmation-templates',
  templateUrl: './booking-final-confirmation-templates.component.html',
  styleUrls: ['./booking-final-confirmation-templates.component.css']
})
export class BookingFinalConfirmationTemplatesComponent implements OnInit {

  constructor(
    public templateService: PdfDocumentTemplateService,
    private httpService: HttpService,
    private confirmationService: ConfirmationService,
    private toastService: ToastMessageService
  ) { }

  templates: BookingFinalConfirmationTemplate[] = [];

  ngOnInit(): void {
    this.httpService.getBookingFinalConfirmationTemplatesByLanguageId(this.templateService.selectedLanguage.id).subscribe(res => {
      this.templateService.finalConfirmationTemplates = res;
    });
  }

  selectTemplateToEdit(template: BookingFinalConfirmationTemplate){
    this.templateService.selectedFinalConfirmationTemplate = template;
    this.templateService.activeItemId = PdfTemplateViewOption.EDIT_FINAL_CONFIRMATION;
  }

  deleteTemplate(templateId: number){
    this.confirmationService.confirm({
      message: "Do you waint to delete the final confirmation template id: " + templateId + "?",
      accept: () => {
        this.httpService.deleteBookingFinalConfirmationTemplate(templateId).subscribe(() => {
          this.removeTemplateFromArray(templateId);
          this.toastService.addSuccess("Success", "Template deleted");
        }, error => this.toastService.addError("Error", "Template could not be deleted"));
      }
    });
  }

  removeTemplateFromArray(templateId: number){
    for(let template of this.templateService.finalConfirmationTemplates){
      if(template.id == templateId){
        const index = this.templateService.finalConfirmationTemplates.indexOf(template);
        this.templateService.finalConfirmationTemplates.splice(index, 1);
      }
    }
  }

}
